import PropTypes from 'prop-types'
import axios from 'axios'

export default function LogInAPI ( props ) {
    const { webId, password, rememberMe, returnUrl, apiUrl, mfaRememberMeData } = props
    const formData  = new FormData()    
    
    formData.append( 'WebId', webId )
    formData.append( 'Password', password )
    formData.append( 'RememberID', rememberMe )
    formData.append( 'ReturnUrl', returnUrl )
    formData.append( 'MfaRememberMeData', mfaRememberMeData || '' )

    return axios.post(
        apiUrl,
        formData,
        { 
            withCredentials: true ,
        } )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}

LogInAPI.propTypes = {
    webId: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    rememberMe: PropTypes.bool.isRequired,
    returnUrl: PropTypes.string.isRequired,
    apiUrl: PropTypes.string.isRequired
}
